module.exports = {
  ALL: [
    {
      name: 'Funapp',
      logo: 'funapp.png',
      amount: {
        TWD: [50,100,200,500,1000,2000,5000],
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./src/config/pay/funapp.js